/* wg-header-scroll.js - Wade Greens
 *
 * Puts .wg-nav-hidden on <html> when the page is scrolled DOWN and takes it
 * off when it is scrolled UP. assets/wg-header-scroll.css does all the moving.
 *
 * WHY THIS IS JAVASCRIPT. CSS cannot read scroll DIRECTION. Scroll-driven
 * animations can, in Chrome - but iOS Safari is most of this store's traffic
 * and does not support them, so a CSS-only version would work everywhere
 * except where it matters. Nothing else here is scripted: the transform, the
 * transition and both breakpoints are in the stylesheet.
 *
 * Shopify's own header script (the one that adds .shopify-section-header-
 * sticky) only pins the desktop header. It has no direction logic, which is
 * why this is not already handled by the theme.
 *
 * TOP    the header is always shown in the first 80px, so every page opens
 *        with it in place.
 * DELTA  6px of travel before it reacts, so a thumb resting on the glass or
 *        iOS rubber-banding does not flicker it.
 * rAF    one class write per frame, passive listener - no scroll jank.
 */
(function () {
  'use strict';

  var TOP = 80;
  var DELTA = 6;

  var root = document.documentElement;
  var last = window.pageYOffset || 0;
  var queued = false;

  function apply() {
    var y = window.pageYOffset || 0;

    if (y <= TOP) {
      root.classList.remove('wg-nav-hidden');
    } else if (y - last > DELTA) {
      root.classList.add('wg-nav-hidden');
    } else if (last - y > DELTA) {
      root.classList.remove('wg-nav-hidden');
    }

    last = y;
    queued = false;
  }

  window.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }, { passive: true });
})();
